import { useEffect } from 'react';
import { ClassicGameDefinition } from '@bg-shared/utils';
import { useStore } from '@betgames/bg-state-manager';
import { useAfterUpdate, useUnmount } from '@betgames/bg-tools';
import { partnerSettingsStore } from '@bg-shared/business/PartnerSettings';
import { GameId } from '@bg-shared/enums/GameId';
import { playerSettingsSelectors, playerSettingsStore } from '@bg-shared/business/PlayerSettings';
import { playerActivityService } from '../PlayerActivity.service';
import { playerActivityStore } from '../PlayerActivity.store';

export const usePlayerActivity = (gameId: GameId): void => {
    const isGuiMode = useStore(playerSettingsStore, playerSettingsSelectors.getGuiMode);
    const state = useStore(playerActivityStore);

    useAfterUpdate(() => {
        playerActivityService.reset();
    }, [gameId]);

    useEffect(() => {
        const shouldTrackInactivity =
            partnerSettingsStore.disableVideoOnInactivity &&
            !isGuiMode &&
            !state.inactive &&
            ClassicGameDefinition.isLive(gameId);

        if (shouldTrackInactivity) {
            playerActivityService.runTimeout();
        }

        return () => {
            playerActivityService.clearTimeout();
        };
    }, [isGuiMode, gameId, state.identity]);

    useUnmount(() => {
        playerActivityService.reset();
    });
};
